import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'ppe_equipment_clothing_provided_not_good_condition_not'

export const dataPointDefinition = {
  retracedId: 'ppe_equipment_clothing_provided_not_good_condition_not',
  name: 'PPE equipment and clothing provided is not in good condition and is not replaced as needed to ensure effectiveness and p',
  description:
    'The intent of this option selection is to understand if PPE equipment and PPE clothing is provided in good working order to protect all workers who need PPE suitably from any applicable hazards.',
  meta: {
    slcpMeta: {
      key: 'hs-wor-19x',
      number: 'HS-WOR-8-1',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'hs-wor-18',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2]',
      machineShowHide: '[2]',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-wor-19x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 31630,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
